export type AppImportMetaEnv = {
  VITE_APP_ID?: string
  VITE_LOCAL_ONLY_PERSIST?: string
  VITE_SUPABASE_URL?: string
  VITE_SUPABASE_ANON_KEY?: string
  VITE_BACKEND_BASE_URL?: string
  VITE_EMAIL_GATEWAY_BASE_URL?: string
  VITE_FEEDBACK_SUBMIT_URL?: string
  VITE_INVITE_USER_URL?: string
  VITE_E2E_MOCK_MODE?: string
} & Record<string, string | boolean | undefined>

export function getAppImportMetaEnv(): AppImportMetaEnv {
  return ((import.meta as ImportMeta & { env?: AppImportMetaEnv }).env) ?? {}
}
